import { faCheckCircle, faClipboard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Badge, Col, Row } from "reactstrap";

const CopyToClipboard = ({ type="none", textToCopy, seconds }) => {
  const [isCopied, setIsCopied] = useState(false);

  const timeSeconds = seconds * 1000 || 2 * 1000;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);

      setTimeout(() => {
        setIsCopied(false);
      }, timeSeconds);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <>
      <Row>
        <Col className="d-flex align-items-baseline mt-1">
          { type == "none" && <p className="mr-2">{textToCopy}</p>}
          { type == "link" && <a href={textToCopy} target="_" className="mr-2">{textToCopy}</a>}
          <Badge
            color={isCopied ? "success" : "primary"}
            onClick={handleCopy}
            style={{
              cursor: "pointer",
              padding: "0.5em",
            }}
          >
            {isCopied ? (
              <>
                <FontAwesomeIcon icon={faCheckCircle} className="mr-1" />{" "}
                {" Copied"}
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faClipboard} className="mr-1" />{" "}
                {" Copy"}
              </>
            )}
          </Badge>
        </Col>
      </Row>
    </>
  );
};

export default CopyToClipboard;
